import React, { Suspense, lazy } from 'react';
import MainLoader from '~components/main-loader';

const NewProjectPage = lazy(() => import('./index.js'))

function NewProjectPageLazy(props) {
    return (
        <Suspense fallback={<MainLoader />}>
            <NewProjectPage {...props} />
        </Suspense>
    );
}

export default NewProjectPageLazy;
export { NewProjectPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/new-project-page/lazy.js